import React from 'react';
import withFallback from '../../components/image-with-fallback';
import { AnimatedCheckmark, MoneyFormat } from '../elements';
import stripHtml from '../../utils/strip-html';
import { ProductVariant } from '../../types';
import useAnimation from '../../hooks/useAnimation';
import { useCandyRackContext } from '../../contexts/CandyRackContext';

const ProductHeader = () => {
  const { parentProduct, parentProductVariantId, upgradeOffer, quantity } =
    useCandyRackContext();
  const canPlayAnimation = useAnimation({
    play: !upgradeOffer,
    playOnce: true,
  });

  if (!parentProduct) return null;

  const variant = parentProduct.variants.find(
    (variant) => variant.id === parentProductVariantId,
  );
  const featured_image =
    (variant && variant.featured_image && variant.featured_image.src) ||
    parentProduct.featured_image;

  function getPrice(quantity: number, variant?: ProductVariant) {
    return variant && (Number(variant.price) * quantity) / 100;
  }

  const offerPrice =
    parentProduct.discountedPrice || getPrice(quantity, variant);

  return (
    <>
      <span className="mr-15 relative bg-grey-5 w-50">
        <img
          src={withFallback(featured_image)}
          alt="Product"
          className="block w-50 h-50 object-cover"
        />
        {!upgradeOffer && (
          <AnimatedCheckmark
            adjustPosition={false}
            size="sm"
            playAnimation={canPlayAnimation}
          />
        )}
      </span>
      <div>
        <div className="Product-Name text-md font-semibold text-grey-1">
          <span className="text-grey-2 font-normal text-md">
            {quantity > 1 ? `${quantity} × ` : ''}
          </span>
          {stripHtml(parentProduct.title)}
        </div>
        {offerPrice ? (
          <span className="Product-Price text-grey-1 font-normal text-md">
            <MoneyFormat amount={offerPrice} />
          </span>
        ) : null}
      </div>
    </>
  );
};

export default ProductHeader;
